import { PureComponent } from 'react';
import { Col, Row } from 'react-bootstrap';
import { ComingSoon } from '../../../components/helpers/ComingSoon';

interface AnalyticsSettingsPageProps {}

export class AnalyticsSettingsPage extends PureComponent<AnalyticsSettingsPageProps> {
    render() {
        const {} = this.props;
        return (
            <div>
                <Row>
                    <Col xs="12">
                        <div className="content">
                            <ComingSoon />
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}
